import { configureStore, combineReducers, Reducer, Tuple } from '@reduxjs/toolkit';
import { ResetStateAction, resetStateActionType } from './action/resetState';
import { createSaveStoreMiddleware } from './middleware/saveStore';
import { createWorkTimeEntrySlice } from './slice/createWorkTimeEntry/createWorkTimeEntrySlice';
export const storeName = 'MainStore';

/**
 * this is defined in an extra variable so it can also be used to initialize the test store
 */
export const storeInitializationData = {
  reducer: {
    createWorkTimeEntry: createWorkTimeEntrySlice.reducer
  },
  middleware: () => new Tuple(createSaveStoreMiddleware(storeName))
};
const reducer = combineReducers({
  createWorkTimeEntry: createWorkTimeEntrySlice.reducer
});
export const store = configureStore<StateFromReducer<typeof reducer>>({
  reducer: (state, action) => {
    if (action.type === resetStateActionType) {
      return (action as ResetStateAction).payload as any;
    }
    return reducer(state, action);
  },
  middleware: () => new Tuple(createSaveStoreMiddleware(storeName))
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
type StateFromReducer<T> = T extends Reducer<infer S, any> ? S : never;